import {
  ADMIN_API_URLS,
  adminApiWrapper,
  getAdminApiErrorMessage
} from '@/shared/api/admin';

import { IAdminErrorResponse } from '@/shared/types/admin-api';

import { TAdminMenuCountersResponse } from '@/entities/admin-menu-counters/model/types/AdminMenuCounters';

/**
 * Загружает счётчики меню админки.
 */
export const getAdminMenuCounters = async () => {
  const response = await adminApiWrapper.get<
    TAdminMenuCountersResponse,
    IAdminErrorResponse
  >(ADMIN_API_URLS.menuCounters);

  if (!response.ok || !response.data) {
    throw new Error(getAdminApiErrorMessage(response.data));
  }

  return response.data;
};
